import { createApp } from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

/**
 * Создаёт и маунтит vue-ui-элементы
 * @param {String} initClass — класс элемента, внутри которого можно будет вызывать компонент
 * @param {Object} component — однофайловый компонент
 * @param {String} componentName — имя для регистрации, по которому можно будет вызывать компонент
 * @param pinia Pinia - экземпляр хранилища pinia
 * */
export default function vueUIInitiator(initClass, component, componentName, pinia) {
    const rootEls = document.querySelectorAll(`.${initClass}`);

    if (!rootEls) return;

    function registComponents() {
        rootEls.forEach((el, idx) => {
            const uniqueClass = `${initClass}-${idx}`;
            el.classList.add(uniqueClass);

            const app = createApp({
                components: {
                    [componentName]: component
                }
            });

            app.use(pinia);
            app.use(VueAxios, axios);

            app.mount(`.${uniqueClass}`);
        });
    }

    registComponents();
}
